import useTabState from '../hooks/useTabState';
import PageLayout from '../components/ui/PageLayout';
import TabBar from '../components/ui/TabBar';
import ClientPolicies from './ClientPolicies';
import ThresholdMgmt from './ThresholdMgmt';
import DetectionRules from './DetectionRules';
import ReferenceLibrary from './ReferenceLibrary';
import SSOSettings from './SSOSettings';
import SkillBuilder from './SkillBuilder';
import IntegrationsTab from './IntegrationsTab';
import CoARoleMappings from './CoARoleMappings';

const TABS = ['CoA Mapping', 'Client Policies', 'Thresholds', 'Detection Rules', 'Reference Library', 'SSO', 'Custom Skills', 'Integrations'] as const;
type Tab = typeof TABS[number];

export default function AppConfiguration() {
  const [activeTab, setActiveTab] = useTabState<Tab>('tab', TABS, 'Thresholds');

  return (
    <PageLayout title="Configuration" subtitle="System settings, rules, and administration">
      <TabBar
        tabs={TABS.map(t => ({ key: t, label: t }))}
        active={activeTab}
        onChange={v => setActiveTab(v as Tab)}
      />
      {activeTab === 'CoA Mapping' && <CoARoleMappings />}
      {activeTab === 'Client Policies' && <ClientPolicies />}
      {activeTab === 'Thresholds' && <ThresholdMgmt />}
      {activeTab === 'Detection Rules' && <DetectionRules />}
      {activeTab === 'Reference Library' && <ReferenceLibrary />}
      {activeTab === 'SSO' && <SSOSettings />}
      {activeTab === 'Custom Skills' && <SkillBuilder />}
      {activeTab === 'Integrations' && <IntegrationsTab />}
    </PageLayout>
  );
}
